import api from "./api";

const route = "/retrasos";

export default {
  getRetrasos: (idProyecto) => api.get(`${route}/${idProyecto}`),
  postRetraso: (idProyecto, retraso) =>
    api.post(`${route}/${idProyecto}`, { ...retraso }),
};
